import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useNavigate } from 'react-router-dom'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { FaRegHandPointRight } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { addFormData, fetchAllDataByIDAPI } from '../utils/api';
import { FcBusinessman } from 'react-icons/fc';

const AddAgent = () => {
    const [validated, setValidated] = useState(false);
    const [values, setAgentValue] = useState();
    const navigate = useNavigate();
    const centerid = localStorage.getItem('centerdata');
    const [member, setMember] = useState([]);

    useEffect(() => {
        if (centerid) {
            navigate('/add-agent');
            getAllMember(centerid)
        }
        else {
            navigate("/");
        }
    }, [centerid]);

    const getAllMember = (centerid) => {
        fetchAllDataByIDAPI(`center-all-center-member-data/${centerid}`).then((res) => {
            if (res.data.status === 1) {
                setMember(...[res.data.memberdata]);
            }
            else {
                toast.warning("Check your connection")
            }
        })
    }

    const handleAgentSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            try {
                const agentdata = { centerid: centerid, agent_name: values.agent_name, agent_member_id: values.agent_member_id, agent_emp_id: values.agent_emp_id, agent_password: values.agent_password };
                addFormData('center-add-center-agent-data', agentdata).then((res) => {
                    if (res.data.status === 1) {
                        toast.success("Agent has been added successfully!");
                        navigate('/agent');
                    }
                    else if (res.data.status === 2) {
                        toast.warning("This Agent already exit!!");
                    }
                    else {
                        toast.error("Something Wrongs!!");
                    }
                })
            }
            catch (error) {
                toast.error("Something is worng!!");
            }
        }
        setValidated(true);
    };

    const handleInputs = e => {
        setAgentValue({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR:WAREHOUSE::ADD AGENT</title>
            </Helmet>
            <ContentWrapper>
                <div className="page-wrapper breadcum">
                    <div className="page-breadcrumb btnbreadcrum d-none d-sm-flex align-items-center justify-between">
                        <div className="">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">Add Agent</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="col-6 col-lg-6 col-xl-6 card cardform">
                        <div className="card border-top border-0 border-4 border-danger">
                            <div className="card-body">
                                <div className="card-title d-flex align-items-center">
                                    <div className="form-heading">
                                        <FcBusinessman className="formIcons" />
                                        <h5 className="mb-0 text-danger">Add Agent</h5>
                                    </div>
                                </div>
                                <hr />
                                <Form noValidate validated={validated} onSubmit={handleAgentSubmit} method="post">
                                    <Row className="mb-3">
                                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Agent Name"
                                                name="agent_name"
                                                onChange={handleInputs}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a agent name
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="validationCustom02">
                                            <Form.Label>Select Member</Form.Label>
                                            <Form.Select required
                                                placeholder="Member Type"
                                                name="agent_member_id"
                                                onChange={handleInputs}>
                                                <option value="">Select Member Type</option>
                                                {member?.map((member,index)=>(
                                                    <option key={index} value={member?.center_mis_id}>{member?.mis_name}</option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid member
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="validationCustom03">
                                            <Form.Label>EMP ID</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Employee ID"
                                                name="agent_emp_id"
                                                onChange={handleInputs}
                                                pattern="[^\s]+"
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid employee ID without space
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="validationCustom04">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                required
                                                type="password"
                                                placeholder="Password"
                                                name="agent_password"
                                                onChange={handleInputs}
                                                minLength={5}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid password
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                    <Button type="submit">Submit</Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default AddAgent